const GameOver = ({ score, onReset }) => {
  return (
    <div className="game-container">
      <div className="game-card">
        <h2 className="game-title">💀 Game Over</h2>
        <p className="status">Your Score: {score}</p>
        <button className="try-again-button" onClick={onReset}>
          Restart
        </button>
      </div>
    </div>
  );
};

export default GameOver;
